// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import React, { useState } from "react";
import { useSelector, shallowEqual } from "react-redux";

import { Toast } from "../../../../web-utils/src/UI/Component/React/V1/Toast/Toast";
import { Button } from "../../../../web-utils/src/UI/Component/React/V1/Button/Button";

// possible types for userMessageError
const typeToToastType = {
  DEBUG: "info",
  INFO: "info",
  WARN: "warning",
  ERROR: "error",
  CRITICAL: "error",
};

export const UserError = () => {
  const { userError, webSocketError, userMessageError } = useSelector(
    (state) => ({
      userError: state.user?.error?.user,
      webSocketError: state.webSocket?.error,
      userMessageError: state.user?.error?.userMessage,
    }),
    shallowEqual,
  );

  const errorToShow = userError || webSocketError;
  const [errorShowing, setError] = useState(errorToShow || userMessageError);

  const renderToast = (type, message) => (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr auto",
        gap: "var(--spacing-2)",
      }}
    >
      <Toast
        msg={{ type, message }}
        showHeader={false}
        position="top-left"
        onClick={() => setError(null)}
      />
      {message === "WebSocket failed after multiple reconnects" && (
        <div style={{ alignSelf: "center", marginRight: "var(--spacing-2)" }}>
          <Button color="error" onClick={() => window.location.reload()}>
            Refresh
          </Button>
        </div>
      )}
    </div>
  );

  return (
    <>
      {errorShowing && errorToShow && renderToast("error", errorToShow)}

      {errorShowing &&
        userMessageError &&
        renderToast(
          typeToToastType[userMessageError.type] ?? "info",
          userMessageError.message,
        )}
    </>
  );
};
